export default __webpack_public_path__ + "static/media/4146.7ba222a7.png";